// import {
//   useCallback,
//   useContext,
//   useEffect,
//   useMemo,
//   useState,
// } from "react";

// import { AuthContext } from "shared/context/AuthContext";


// const TTL = 1000 * 60 * 5;

// const EMPTY_DATA = {
//   status: "idle",
//   projects: [],
// };


// const readCachedData = () => {
//   try {
//     const stored = localStorage.getItem("okdData");

//     if (!stored) {
//       return null;
//     }

//     const parsed = JSON.parse(stored);

//     if (Array.isArray(parsed?.projects)) {
//       return parsed;
//     }

//     // Obsługa starego cache będącego tablicą.
//     if (Array.isArray(parsed)) {
//       return {
//         status: "success",
//         projects: parsed,
//       };
//     }

//     return null;
//   } catch {
//     return null;
//   }
// };


// export const useOkdData = () => {
//   const { state, setContext } = useContext(AuthContext);

//   const contextData = useMemo(() => {
//     if (Array.isArray(state.okdData?.projects)) {
//       return state.okdData;
//     }

//     if (Array.isArray(state.okdData)) {
//       return {
//         status: "success",
//         projects: state.okdData,
//       };
//     }

//     return null;
//   }, [state.okdData]);

//   const storedData = useMemo(
//     () => readCachedData(),
//     []
//   );

//   const cachedData = contextData || storedData;

//   const storedLastFetch = useMemo(
//     () =>
//       Number(
//         localStorage.getItem("okdDataLastFetch")
//       ) || 0,
//     []
//   );

//   const cachedLastFetch =
//     state.okdDataLastFetch ||
//     storedLastFetch;

//   const hasCachedProjects =
//     Array.isArray(cachedData?.projects) &&
//     cachedData.projects.length > 0;

//   const isCacheValid =
//     hasCachedProjects &&
//     cachedLastFetch > 0 &&
//     Date.now() - cachedLastFetch < TTL;

//   const [data, setData] = useState(
//     cachedData || EMPTY_DATA
//   );
//   const [loading, setLoading] = useState(
//     !isCacheValid
//   );
//   const [error, setError] = useState(null);

//   const fetchData = useCallback(
//     async (force = false) => {
//       if (
//         !state.isAuthUser ||
//         state.isOkdAvailable !== true
//       ) {
//         setLoading(false);
//         return;
//       }

//       // if (
//       //   !force &&
//       //   cachedData &&
//       //   isCacheValid
//       // ) {
//       //   setData(cachedData);
//       //   setLoading(false);
//       //   return;
//       // }
//       if (
//         !force &&
//         cachedData &&
//         isCacheValid
//       ) {
//         setData(cachedData);
//         setLoading(false);
//         return true;
//       }

//       setLoading(true);
//       setError(null);

//       // console.log(
//       //   "[useOkdData] GET user-projects"
//       // );
//       try {
//         const resp = await fetch(
//           `${process.env.REACT_APP_API_URL}` +
//             "/ti/api/okd/user-projects/",
//           {
//             credentials: "include",
//           }
//         );

//         if (!resp.ok) {
//           throw new Error(`HTTP ${resp.status}`);
//         }

//         const result = await resp.json();
//         // console.log(
//         //   "[useOkdData] response",
//         //   result
//         // );

//         if (
//           result.status !== "success" ||
//           !Array.isArray(result.projects)
//         ) {
//           throw new Error("Invalid OKD response");
//         }

//         setData(result);

//         if (result.projects.length > 0) {
//           const fetchedAt = Date.now();

//           setContext({
//             okdData: result,
//             okdDataLastFetch: fetchedAt,
//           });

//           localStorage.setItem(
//             "okdData",
//             JSON.stringify(result)
//           );

//           localStorage.setItem(
//             "okdDataLastFetch",
//             fetchedAt.toString()
//           );
//         } else {
//           // Nie zapisujemy pustej odpowiedzi w kontekście
//           // ani w cache, aby umożliwić kolejną próbę.
//           localStorage.removeItem("okdData");
//           localStorage.removeItem(
//             "okdDataLastFetch"
//           );
//         }
//       } catch (err) {
//         // console.error(
//         //   "Failed to fetch OKD data:",
//         //   err
//         // );

//         if (cachedData) {
//           setData(cachedData);
//         } else {
//           setError(err);
//         }

//         return false;
//       } finally {
//         setLoading(false);
//       }
//     },
//     [
//       state.isAuthUser,
//       state.isOkdAvailable,
//       cachedData,
//       isCacheValid,
//       setContext,
//     ]
//   );
//   // useEffect(() => {
//   //   if (
//   //     !state.isAuthUser ||
//   //     state.isOkdAvailable !== true
//   //   ) {
//   //     setLoading(false);
//   //     return;
//   //   }

//   //   fetchData();
//   // }, [
//   //   state.isAuthUser,
//   //   state.isOkdAvailable,
//   //   fetchData,
//   // ]);
//   useEffect(() => {
//     // console.log("[useOkdData] effect", {
//     //   isAuthUser: state.isAuthUser,
//     //   isOkdAvailable: state.isOkdAvailable,
//     // });

//     if (
//       !state.isAuthUser ||
//       state.isOkdAvailable !== true
//     ) {
//       setLoading(false);
//       return;
//     }

//     // console.log("[useOkdData] starting fetch");
//     fetchData();
//   }, [
//     state.isAuthUser,
//     state.isOkdAvailable,
//     fetchData,
//   ]);

//   return {
//     data,
//     loading,
//     error,
//     refetch: () => {
//       if (
//         !state.isAuthUser ||
//         state.isOkdAvailable !== true
//       ) {
//         return Promise.resolve(false);
//       }

//       return fetchData(true);
//     },
//   };
// };
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { AuthContext } from "shared/context/AuthContext";


const TTL = 1000 * 60 * 5;
const REQUEST_TIMEOUT = 60_000;

const EMPTY_DATA = {
  status: "idle",
  projects: [],
};


const readCachedData = () => {
  try {
    const stored = localStorage.getItem(
      "okdData"
    );

    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);

    if (Array.isArray(parsed?.projects)) {
      return parsed;
    }

    // Obsługa starego cache zapisanego jako tablica.
    if (Array.isArray(parsed)) {
      return {
        status: "success",
        projects: parsed,
      };
    }

    return null;
  } catch {
    return null;
  }
};


export const useOkdData = () => {
  const { state, setContext } =
    useContext(AuthContext);

  const cachedData = useMemo(() => {
    if (Array.isArray(state.okdData?.projects)) {
      return state.okdData;
    }

    if (Array.isArray(state.okdData)) {
      return {
        status: "success",
        projects: state.okdData,
      };
    }

    return readCachedData();
  }, [state.okdData]);

  const cachedLastFetch =
    state.okdDataLastFetch ||
    Number(
      localStorage.getItem(
        "okdDataLastFetch"
      )
    ) ||
    0;

  /*
   * Pusta tablica projektów również jest prawidłową
   * odpowiedzią OKD. Dzięki temu nie tworzymy pętli
   * kolejnych requestów.
   */
  const hasCachedData =
    Array.isArray(cachedData?.projects);

  const isCacheValid =
    hasCachedData &&
    cachedLastFetch > 0 &&
    Date.now() - cachedLastFetch < TTL;

  const [data, setData] = useState(
    cachedData || EMPTY_DATA
  );

  const [loading, setLoading] = useState(
    !isCacheValid
  );

  const [error, setError] = useState(null);

  const abortControllerRef = useRef(null);

  const fetchData = useCallback(
    async (force = false) => {
      if (
        !state.isAuthUser ||
        state.areIntegrationsReady !== true ||
        state.isOkdAvailable !== true
      ) {
        setLoading(false);
        return false;
      }

      if (
        !force &&
        cachedData &&
        isCacheValid
      ) {
        setData(cachedData);
        setLoading(false);
        return true;
      }

      abortControllerRef.current?.abort();

      const controller = new AbortController();
      abortControllerRef.current = controller;

      let didTimeout = false;

      const timeoutId = setTimeout(() => {
        didTimeout = true;
        controller.abort();
      }, REQUEST_TIMEOUT);

      setLoading(true);
      setError(null);

      try {
        const resp = await fetch(
          `${process.env.REACT_APP_API_URL}` +
            "/ti/api/okd/user-projects/",
          {
            credentials: "include",
            signal: controller.signal,
          }
        );

        const result = await resp
          .json()
          .catch(() => null);

        if (resp.status === 401) {
          setContext({
            isOkdAvailable: false,
          });

          throw new Error(
            result?.message ||
              result?.detail ||
              "Brak aktywnej sesji OKD"
          );
        }

        if (!resp.ok) {
          throw new Error(
            result?.message ||
              result?.detail ||
              `HTTP ${resp.status}`
          );
        }

        if (
          result?.status !== "success" ||
          !Array.isArray(result.projects)
        ) {
          throw new Error(
            "Invalid OKD response"
          );
        }

        const fetchedAt = Date.now();

        setData(result);

        setContext({
          okdData: result,
          okdDataLastFetch: fetchedAt,
          isOkdAvailable: true,
        });

        return true;
      } catch (err) {
        if (err.name === "AbortError") {
          if (didTimeout) {
            const timeoutError = new Error(
              "Przekroczono czas pobierania danych OKD"
            );

            console.error(
              "Failed to fetch OKD data:",
              timeoutError
            );

            if (!cachedData) {
              setError(timeoutError);
            }
          }

          return false;
        }

        console.error(
          "Failed to fetch OKD data:",
          err
        );

        if (cachedData) {
          setData(cachedData);
        } else {
          setError(err);
        }

        return false;
      } finally {
        clearTimeout(timeoutId);

        if (
          abortControllerRef.current ===
          controller
        ) {
          setLoading(false);
        }
      }
    },
    [
      state.isAuthUser,
      state.areIntegrationsReady,
      state.isOkdAvailable,
      cachedData,
      isCacheValid,
      setContext,
    ]
  );

  useEffect(() => {
    if (
      !state.isAuthUser ||
      state.areIntegrationsReady !== true ||
      state.isOkdAvailable !== true
    ) {
      setLoading(false);
      return;
    }

    fetchData();

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [
    state.isAuthUser,
    state.areIntegrationsReady,
    state.isOkdAvailable,
    fetchData,
  ]);

  return {
    data,
    loading,
    error,

    refetch: () => {
      if (
        !state.isAuthUser ||
        state.areIntegrationsReady !== true ||
        state.isOkdAvailable !== true
      ) {
        return Promise.resolve(false);
      }

      return fetchData(true);
    },
  };
};